import ApiService from '../../../../../../services/ApiService'
import Utils from '../../../../../../Utils/FormatDate'

export default {
  props: {
    filterProp: Object,
  },
  components: {},

  data() {
    return {
      apiService: new ApiService(),
      loading: false,
      showChart: true,
      totalServiceTime: [],
      expanded: [],
      page: 1,
      totalPages: 1,
      pageSize: 7,
      headerProps: {
        sortByText: 'Ordenar por',
      },
      header: [
        {
          text: 'Tempo Atendimento (horas)',
          align: 'center',
          value: 'serviceTime',
        },
      ],
      total: 0,
    }
  },
  async created() {
    this.listServiceTime()
  },
  methods: {
    requestExcel() {
      this.filterProp.pageSize = 10000
      let now = new Date()
      var filename = `Requested_V_Completed_${now.getDate()}-${
        now.getMonth() + 1
      }-${now.getFullYear()}.xlsx`
      this.apiService
        .post('excel/requestedCompleted', this.filterProp)
        .then((response) => {
          response = `data:application/octet-stream;base64,${response.content}`
          const link = document.createElement('a')
          link.href = response
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        })
    },
    async listServiceTime() {
      this.loading = true
      this.totalServiceTime = []
      await this.apiService
        .post('reports/totalServiceTime', this.filterProp)
        .then((response) => {
          this.total = response.content.pager.totalItems
          this.totalServiceTime.push(response.content)
          this.showChart = this.totalServiceTime.length > 0
        })
        .catch((err) => {})
      this.loading = false
    },

    formatDate(date) {
      return Utils.dateTime(date)
    },
  },
  watch: {
    page() {
      this.filterProp.page = this.page
      this.listServiceTime()
    },
  },
}
